import { Record, List, Map } from 'immutable';
import get from 'lodash/get';
import { getDefaultLocale } from 'labels/locale';
import { storage } from 'lib/storage';

import { DEFAULT_PANEL_WIDTH } from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/StyledComponents';

import botPic from './images/bot.png';

const PermissionsNotesFactory = new Record({
  isCreate: false,
  isUpdate: false,
  isDelete: false,
});

export const PermissionsFactory = new Record({
  isDokkaSupport: false,
  superUser: false,
  notes: PermissionsNotesFactory(),
});

export const OrgBotFactory = new Record({
  userId: '',
  username: 'BOT',
  picture: botPic,
});

export const UserFeaturesFactory = new Record({
  modal: true,
  filter_documents_tagged_by_user_only: false,
});

export function permissionsAdapter({ notes, ...rest }) {
  const notesRecord = PermissionsNotesFactory({
    isCreate: get(notes, 'create'),
    isUpdate: get(notes, 'update'),
    isDelete: get(notes, 'delete'),
  });
  return PermissionsFactory({
    ...rest,
    notes: notesRecord,
  });
}

export function featuresAdapter(features) {
  return UserFeaturesFactory(features);
}

export function orgBotAdapter({ userID, displayName, picture, ...rest }) {
  const pictureObj = picture ? { picture } : {};
  return OrgBotFactory({
    ...rest,
    userId: userID,
    username: displayName,
    ...pictureObj,
  });
}

export const roleModificatorsFactory = new Record({
  limited: false,
  restricted: false,
  readonly: false,
});

export function roleModificatorsAdapter(data) {
  return roleModificatorsFactory(data);
}

export const appFactory = new Record({
  active: false,
  appName: '',
  appUrl: '',
  companiesContext: [],
});

export function appsAdapter(data) {
  return Object.keys(data).reduce((acc, key) => acc.set(key, appFactory(data[key])), new Map());
}

export const PayModuleCompanyPermissionFactory = new Record({
  accountId: '',
  isApprover: false,
  isController: false,
  isOwner: false,
});

export const payModuleCompanyPermissionsAdapter = (permissions) =>
  new List(permissions.map(PayModuleCompanyPermissionFactory));

export const EnvFactory = new Record({
  dokkaToken: '',
  role: null,
  build: process.env.REACT_APP_BUILD_VERSION,
  rtl: getDefaultLocale() === 'he',
  locale: getDefaultLocale(),
  loading: 0,
  isSagaDataLoading: false,
  linkedSidebarWidth: DEFAULT_PANEL_WIDTH,
  view: new Map(),
  paymentView: new Map(),
  chatToken: '',
  chatUser: '',
  organizationId: '', // empty indicating default value, backend will send real id or null
  organizationName: '',
  firstName: '',
  lastName: '',
  picture: '',
  phone: '',
  permissions: PermissionsFactory(),
  superUser: false,
  isDokkaSupport: false,
  backSearchUrl: null,
  persistedBackUrl: null,
  userId: null,
  navigation: new Map(),
  isExpired: false,
  userGUID: null,
  title: '',
  label: null,
  newChatFlow: false,
  googleSearchText: null,
  googlePanelStatus: false,
  appStatuses: new List(),
  helpdeskLink: null,
  workSpace: new Map(),
  organizationBot: OrgBotFactory(),
  features: UserFeaturesFactory(),
  allowFreshdesk: false,
  error: '',
  supplierAliases: '',
  roleModificators: roleModificatorsFactory(),
  connectionHealth: true,
  cognitoUsername: null,
  apps: new Map(),
  beta: false,
  isRecordingEnabled: false,
  payModuleCompanyPermissions: new List(),
  isPayModuleCompanyPermissionsLoaded: false,
});

// eslint-disable-next-line max-len
export function envAdapter({ permissions, restricted, limited, readonly, ...rest }) {
  const permissionsRecord = permissionsAdapter(permissions || {});
  const roleModificatorsRecord = roleModificatorsAdapter({ restricted, limited, readonly });
  const workSpaceStr = storage().workSpaceType().get();
  const workSpace = workSpaceStr ? JSON.parse(workSpaceStr) : {};
  const persistedBackUrl = storage().backUrl().get();

  return EnvFactory({
    ...rest,
    persistedBackUrl,
    permissions: permissionsRecord,
    roleModificators: roleModificatorsRecord,
    workSpace: new Map(workSpace),
  });
}
